(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section-explore/assets/javascripts/casino-section-explore.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section-explore/assets/javascripts/casino-section-explore.js');

'use strict';

const {
  useMemo,
  useState,
  useCallback
} = React;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  CasinoGrid
} = svs.components.casino_react;
const {
  ReactButton: Button,
  ReactButtonGroup: ButtonGroup
} = svs.ui;
const {
  cmsCategoryList,
  cmsLiveCategoryList,
  cmsProviderList,
  cmsGameList,
  brand
} = svs.casino_react.shared.data;
const {
  QuickSearchPills
} = svs.components.casino_react.quickSearchPills;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const TABS = {
  POPULAR: 'popular',
  CATEGORIES: 'categories',
  LIVE_CATEGORIES: 'liveCategories',
  PROVIDERS: 'providers'
};
const fallbackPlayList = {
  list: [],
  displayMode: GridDisplayModes.GRID_UNRESTRICTED
};
const CasinoSectionExplore = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabFromUrl = urlParams.get('tab');
  const tabExistsOnTabs = Object.values(TABS).includes(tabFromUrl) ? tabFromUrl : TABS.POPULAR;
  const [activeTab, setActiveTab] = useState(tabExistsOnTabs);
  const isLargeScreen = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  const activeList = useMemo(() => {
    switch (activeTab) {
      case TABS.CATEGORIES:
        return {
          list: cmsCategoryList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.LIVE_CATEGORIES:
        return {
          list: cmsLiveCategoryList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.PROVIDERS:
        return {
          list: cmsProviderList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.POPULAR:
      default:
        return {
          list: cmsGameList,
          displayMode: GridDisplayModes.GRID_RESTRICTED_DOUBLE_ROW
        } || fallbackPlayList;
    }
  }, [activeTab]);
  const handleTabChange = useCallback(tab => {
    setActiveTab(tab);
    const url = new URL(window.location);
    url.searchParams.set('tab', tab);
    window.history.pushState({}, '', url);
  }, []);
  const renderedContent = useMemo(() => {
    if (!activeList.list.length) {
      handleTabChange(TABS.POPULAR);
    }
    return React.createElement(CasinoGrid, {
      displayMode: activeList.displayMode,
      items: activeList.list
    });
  }, [activeList, handleTabChange]);
  const showCategoryButtons = activeTab === TABS.CATEGORIES || activeTab === TABS.LIVE_CATEGORIES;
  return React.createElement("div", {
    className: "casino-section-explore"
  }, React.createElement("div", {
    className: "casino-section-explore__heading f-content"
  }, React.createElement("h2", null, "Utforska")), React.createElement(ItemsMenu, {
    branding: brand,
    centered: isLargeScreen,
    className: "casino-section-explore__navigation",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, React.createElement(LinkItem, {
    Component: "button",
    label: "Popul\xE4rt",
    onClick: () => handleTabChange(TABS.POPULAR),
    selected: activeTab === TABS.POPULAR
  }), React.createElement(LinkItem, {
    className: "casino-section-explore__item-category",
    Component: "button",
    label: "Kategorier",
    onClick: () => handleTabChange(TABS.CATEGORIES),
    selected: activeTab === TABS.CATEGORIES || activeTab === TABS.LIVE_CATEGORIES
  }), React.createElement(LinkItem, {
    Component: "button",
    label: "Leverant\xF6r",
    onClick: () => handleTabChange(TABS.PROVIDERS),
    selected: activeTab === TABS.PROVIDERS
  })), showCategoryButtons && React.createElement("div", {
    className: "casino-section-explore__category-buttons col-xs-12 col-md-6"
  }, React.createElement(ButtonGroup, {
    block: true
  }, React.createElement(Button, {
    className: "col-xs-6",
    inverted: activeTab === TABS.CATEGORIES,
    onClick: () => handleTabChange(TABS.CATEGORIES),
    size: 300,
    transparent: activeTab !== TABS.CATEGORIES
  }, "Casino"), React.createElement(Button, {
    className: "col-xs-6",
    inverted: activeTab === TABS.LIVE_CATEGORIES,
    onClick: () => handleTabChange(TABS.LIVE_CATEGORIES),
    size: 300,
    transparent: activeTab !== TABS.LIVE_CATEGORIES
  }, "Live Casino"))), React.createElement("div", {
    className: "casino-section-explore__content"
  }, activeTab === TABS.POPULAR && React.createElement(QuickSearchPills, null), renderedContent));
};
setGlobal('svs.components.casino_react.CasinoSectionExplore', CasinoSectionExplore);

 })(window);